function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27 28C22.9613 28.0071 18.9729 27.1055 15.33 25.362C9.7872 22.6882 5.31347 18.2159 2.63797 12.674C0.894119 9.0298 -0.00747724 5.03994 -3.11311e-05 1C-3.11311e-05 0.734784 0.105326 0.48043 0.292862 0.292893C0.480398 0.105357 0.734752 0 0.999969 0H6.09997C7.13669 0.000975132 7.99862 0.798473 8.07997 1.832C8.27644 3.99739 8.82991 6.11534 9.71797 8.1C10.1546 9.07126 9.75368 10.2143 8.80597 10.7L4.88197 12.676C7.24375 17.1151 10.8768 20.7482 15.316 23.11L17.292 19.2C17.7776 18.2523 18.9207 17.8513 19.892 18.288C21.8763 19.1774 23.9943 19.7316 26.16 19.928C27.1908 20.0149 27.9853 20.8735 27.992 21.908V27C27.992 27.5492 27.5491 27.9956 27 28ZM17.124 23.98C19.9345 25.1867 22.9435 25.8647 26 25.98V21.9C23.6098 21.6933 21.2716 21.0847 19.084 20.1L17.124 23.98ZM4.01997 10.876C2.8129 8.06558 2.13488 5.05652 2.01997 2L6.08797 2.01C6.30353 4.39898 6.91875 6.73479 7.90797 8.92L4.01997 10.876Z",
  fill: "#32D882"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21 14H15C14.4477 14 14 13.5523 14 13V12C14 9.23858 16.2386 7 19 7C19.5523 7 20 6.55228 20 6V5C20 4.44772 19.5523 4 19 4H15C14.4477 4 14 3.55228 14 3C14 2.44772 14.4477 2 15 2H19C20.6569 2 22 3.34315 22 5V6C22 7.65685 20.6569 9 19 9C17.3431 9 16 10.3431 16 12H21C21.5523 12 22 12.4477 22 13C22 13.5523 21.5523 14 21 14Z",
  fill: "#32D882"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31 14C30.4477 14 30 13.5523 30 13V3C30 2.44772 30.4477 2 31 2C31.5523 2 32 2.44772 32 3V13C32 13.5523 31.5523 14 31 14Z",
  fill: "#32D882"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M31 10H25C24.6784 10.0004 24.3762 9.84608 24.188 9.58531C23.9997 9.32453 23.9484 8.98914 24.05 8.684L26.05 2.684C26.2245 2.15988 26.7909 1.87647 27.315 2.051C27.8391 2.22552 28.1226 2.79188 27.948 3.316L26.386 8H31C31.5523 8 32 8.44771 32 9C32 9.55228 31.5523 10 31 10Z",
  fill: "#32D882"
});

var SvgVenueManagment7 = function SvgVenueManagment7(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVenueManagment7, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/venue-managment7.92bbd9c4.svg";
export { ForwardRef as ReactComponent };